import React from 'react'

const WrenchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
)

const EnvelopeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const REPORT_TYPES = [
  {
    key: 'damage',
    icon: <WrenchIcon />,
    title: 'Damage Report',
    description: 'Report a physical damage that needs to be repaired.',
  },
  {
    key: 'inquiry',
    icon: <EnvelopeIcon />,
    title: 'Other / General Inquiry',
    description: 'Ask a question or submit a general service request.',
  },
]

interface ReportTypeStepProps {
  value: string
  onChange: (value: string) => void
}

const ReportTypeStep = ({ value, onChange }: ReportTypeStepProps) => (
  <div>
    <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#0a0d47', margin: '0 0 4px' }}>What type of report is this?</h3>
    <p style={{ fontSize: '0.875rem', color: '#9ca3af', margin: '0 0 24px' }}>Choose how you want to proceed.</p>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {REPORT_TYPES.map((type) => {
        const selected = value === type.key
        return (
          <button
            key={type.key}
            type="button"
            onClick={() => onChange(type.key)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              padding: '20px 24px',
              borderRadius: '12px',
              border: `2px solid ${selected ? '#2196F3' : '#e5e7eb'}`,
              backgroundColor: selected ? '#EFF6FF' : '#fff',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'border-color 0.15s, background-color 0.15s',
              width: '100%',
            }}
          >
            <span style={{ color: selected ? '#2196F3' : '#9ca3af', lineHeight: 0, flexShrink: 0 }}>
              {type.icon}
            </span>
            <div>
              <p style={{ margin: '0 0 2px', fontSize: '0.875rem', fontWeight: 500, color: selected ? '#2196F3' : '#374151' }}>
                {type.title}
              </p>
              <p style={{ margin: 0, fontSize: '0.875rem', color: '#9ca3af' }}>
                {type.description}
              </p>
            </div>
          </button>
        )
      })}
    </div>
  </div>
)

export default ReportTypeStep
